// Phase 2/3 - BLM National PLSS integration.

const BLM_URL = 'https://gis.blm.gov/arcgis/rest/services/Cadastral/BLM_Natl_PLSS_CadNSDI/MapServer';

// ---- Phase 2: raster overlay on the map ----
export function addPlssLayer(map) {
  if (!map || map.getSource('plss')) return;
  const tileUrl = BLM_URL + '/export?bbox={bbox-epsg-3857}&bboxSR=3857&imageSR=3857&size=512,512&format=png32&transparent=true&dpi=96&f=image';
  map.addSource('plss', {
    type: 'raster',
    tiles: [tileUrl],
    tileSize: 512,
    minzoom: 8,
    maxzoom: 22,
    attribution: 'PLSS: <a href="https://www.blm.gov/services/geospatial/PLSS" target="_blank" rel="noopener">BLM National PLSS CadNSDI</a>',
  });
  const beforeId = map.getLayer('parcels-fill') ? 'parcels-fill' : undefined;
  map.addLayer({ id: 'plss-raster', type: 'raster', source: 'plss', paint: { 'raster-opacity': 0.75 } }, beforeId);
}

// ---- Phase 3: fetch vector aliquot cells for a parcel bbox ----
// Uses our Netlify proxy to avoid CORS and keep BLM endpoint configurable.
// Returns a GeoJSON FeatureCollection of PLSSSecondDivision (aliquot) cells
// whose geometry intersects the parcel's bounding box, buffered a little.
export async function fetchPlssAliquotsForParcel(parcelFeature) {
  const bbox = bboxOf(parcelFeature);
  if (!bbox) return { type: 'FeatureCollection', features: [] };
  // Pad the bbox a touch so we get neighboring cells too (helps detect cases
  // where a parcel aligns to a boundary that barely misses its own bbox).
  const pad = 0.0005; // ~50m in lat/lon at mid-latitudes
  const padded = [bbox[0] - pad, bbox[1] - pad, bbox[2] + pad, bbox[3] + pad];
  const resp = await fetch('/.netlify/functions/plss', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bbox: padded.join(','), layer: '3' }),
  });
  if (!resp.ok) throw new Error('PLSS fetch failed: ' + resp.status);
  const data = await resp.json();
  if (data.type === 'FeatureCollection') return data;
  return { type: 'FeatureCollection', features: [] };
}

function bboxOf(feature) {
  if (!feature || !feature.geometry) return null;
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  const walk = (coords) => {
    if (typeof coords[0] === 'number') {
      if (coords[0] < minX) minX = coords[0];
      if (coords[0] > maxX) maxX = coords[0];
      if (coords[1] < minY) minY = coords[1];
      if (coords[1] > maxY) maxY = coords[1];
    } else {
      for (const c of coords) walk(c);
    }
  };
  walk(feature.geometry.coordinates);
  if (!isFinite(minX)) return null;
  return [minX, minY, maxX, maxY];
}
